/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.device', [])
    .factory('deviceService', DeviceService)
    .name;

/*@ngInject*/
function DeviceService($http, $q, types, wsSubscriptionService) {

    var service = {
        deleteDevice: deleteDevice,
        deleteSystemDevice: deleteSystemDevice,
        getDevice: getDevice,
        getDeviceFCnts: getDeviceFCnts,
        saveDevice: saveDevice,
        saveDeviceBulkProvisioning: saveDeviceBulkProvisioning,
        saveDeviceFCnts: saveDeviceFCnts,
        requestDeviceStatus: requestDeviceStatus,
        getDeviceGroupDevices: getDeviceGroupDevices,
        subscribeForDeviceStateData: subscribeForDeviceStateData,
        subscribeForDeviceStatsData: subscribeForDeviceStatsData,
        getSystemDeviceByEui: getSystemDeviceByEui,
        getAllEuis: getAllEuis,
    };

    return service;

    function getDeviceGroupDevices (applicationId) {
        var deferred = $q.defer();
        $http.get(`/api/application/${applicationId}/devices`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getDevice (deviceId) {
        var deferred = $q.defer();
        var url = '/api/device/' + deviceId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getDeviceFCnts (deviceId) {
        var deferred = $q.defer();
        var url = '/api/device/' + deviceId + '/fcnts';
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveDevice (device) {
        var deferred = $q.defer();
        var url = '/api/device';
        $http.post(url, device).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveDeviceBulkProvisioning(device) {
        var deferred = $q.defer();
        var url = '/api/device';
        $http.post(url, device, {ignoreErrors: true}).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(rejection) {
            deferred.reject(rejection);
        });
        return deferred.promise;
    }

    function saveDeviceFCnts (deviceId, deviceFCnts) {
        var deferred = $q.defer();
        if (!deviceFCnts) {
            deviceFCnts = {};
        }
        var url = '/api/device/' + deviceId + '/fcnts';
        $http.post(url, deviceFCnts).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function requestDeviceStatus(deviceId) {
        var deferred = $q.defer();
        var url = `/api/macCommand/${deviceId}/devStatus`;
        $http.post(url, null).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteDevice (deviceId) {
        var deferred = $q.defer();
        var url = '/api/device/' + deviceId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteSystemDevice (deviceId) {
        var deferred = $q.defer();
        var url = '/api/system/device/' + deviceId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function subscribeForDeviceStateData(deviceId, onData) {
        var subscriptionCommand = {
            entityType: types.entityType.device,
            entityId: deviceId,
            type: types.wsSubscriptionType.state
        };
        var subscriber = {
            subscriptionCommand: subscriptionCommand,
            onData: function (data) {
                if (data.data) {
                    onData(data.data);
                }
            }
        };
        return wsSubscriptionService.subscribe(subscriber);
    }

    function subscribeForDeviceStatsData(deviceId, onStatsData, onReconnected) {
        var subscriptionCommand = {
            entityType: types.entityType.device,
            entityId: deviceId,
            type: types.wsSubscriptionType.stats
        };
        var subscriber = {
            subscriptionCommand: subscriptionCommand,
            onData: function (data) {
                if (data.data) {
                    onStatsData(data.data);
                }
            },
            onReconnected: function () {
                if (onReconnected) {
                    onReconnected();
                }
            }
        };
        return wsSubscriptionService.subscribe(subscriber);
    }

    function getSystemDeviceByEui(deviceEui) {
        var deferred = $q.defer();

        $http.get('/api/system/device/eui/' + deviceEui).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });

        return deferred.promise;
    }

    function getAllEuis() {
        var deferred = $q.defer();

        $http.get('/api/devices/eui').then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });

        return deferred.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/device.service.js